import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import vertText from "_src/shaders/blur/blur.glslv";
import fragText from "_src/shaders/blur/blur.glslf";

import { vec2 } from "_src/libs/gl-matrix";

export default class BlurShader extends Shader {

  constructor(params) {

    super(params);

    this.attachUniforms();

  }

  //reimplementation
  initDirectives(params) {
    this._directives["HOR_DIR"] = params.horDir !== undefined ? params.horDir : true;
  }

  updateSceneUniformValues(scene) {
    const camera = scene.camera;
    vec2.copy(this.uniforms["u_texel_size"].value, camera.texelSize);
  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms() {
    const texelSize = vec2.create();

    this.uniforms["u_text_diffuse"] = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
    this.uniforms["u_texel_size"] = new Uniform(uniformType.FLOAT2V, texelSize, uniformSource.SCENE);
  }

}
